module.exports = __webpack_public_path__ + "static/media/sura-pin.f3ff18a7.svg";